
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.241 7.746a.811.811 0 011.072-.081l.092.08L12 14.474l6.595-6.727a.811.811 0 011.072-.081l.092.08a.852.852 0 01.08 1.094l-.08.094-7.177 7.321a.811.811 0 01-1.072.081l-.092-.08-7.177-7.322a.852.852 0 010-1.187z","fill":"#224CA4"}})])
          )
        }
      }
    